import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GoogleTagManager } from '@next/third-parties/google';
import { useEffect, useMemo, useState } from 'react';
import { ErrorBoundary } from '../../errors';
import { createInstance as createI18nInstance, } from '../../types';
export function NextAppRoot({ context, AppComponent, router, pageProps, translationProps, Component, }) {
    const [loading, setLoading] = useState(false);
    // i18next support
    const i18n = useMemo(() => {
        // translations enabled?
        if (!translationProps)
            return null;
        const { namespaces, resources, lng, defaultNS, initOptions } = translationProps;
        const i18n = createI18nInstance({
            ns: namespaces,
            resources,
            lng,
            defaultNS,
            react: { useSuspense: false },
            interpolation: {
                escapeValue: false, // not necessary with react: https://www.i18next.com/translation-function/interpolation#unescape
            },
            ...initOptions,
        });
        // as long as we pass the resources object directly, the initialization will finish immediately
        void i18n.init((error) => {
            if (error) {
                console.error('🚨 i18n initialization failed', { error });
            }
        });
        return i18n;
    }, [translationProps]);
    // handle loading
    useEffect(() => {
        const handleStart = () => {
            setLoading(true);
        };
        const handleComplete = () => {
            setLoading(false);
        };
        router.events.on('routeChangeStart', handleStart);
        router.events.on('routeChangeComplete', handleComplete);
        router.events.on('routeChangeError', handleComplete);
    }, [router]);
    const gtm = context.config.gtm;
    const dataLayer = context.appInstance.getGtmDataLayer?.({
        debug: context.config.debug,
    });
    return (_jsxs(ErrorBoundary, { children: [gtm?.id && (_jsx(GoogleTagManager
            // GTMParams type in Next.js is currently wrong and will be fixed with: https://github.com/vercel/next.js/pull/66339
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            , { 
                // GTMParams type in Next.js is currently wrong and will be fixed with: https://github.com/vercel/next.js/pull/66339
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                dataLayer: dataLayer, gtmId: gtm.id, preview: gtm.preview, auth: gtm.auth })), _jsx(AppComponent, { context: context, router: router, i18n: i18n, pageProps: pageProps, Component: Component, loading: loading })] }));
}
